export const receiveSegmentMembers = segmentMembers => {
  return {
    type: 'RECEIVE_SEGMENT_MEMBERS',
    segmentMembers
  }
}

export const receiveSegmentDetails = segmentDetails => {
  return {
    type: 'RECEIVE_SEGMENT_DETAILS',
    segmentDetails
  }
}

export const selectMember = selectedId => {
  return {
    type: 'SELECT_SEGMENT_MEMBER',
    selectedId
  }
}

export const deselectMember = deselectedId => {
  return {
    type: 'DESELECT_SEGMENT_MEMBER',
    deselectedId
  }
}